<template>
  <SingleLayout :loading="fetching">
    <!--
    Header Content
    -->
    <template #header>
      <div class="flex -mx-4">
        <div class="flex-none px-4">
          <div class="w-32 h-32 rounded-full bg-gray-200" />
        </div>
        <div class="flex-1 px-4">
          <h4 class="text-white">{{ user.firstName }} {{ user.lastName }}</h4>
          <p class="text-indigo-300">@{{ user.name }}</p>
        </div>
      </div>
    </template>

    <!--
    Main Content
    -->
    <RouterView />
  </SingleLayout>
</template>

<script>
import SingleLayout from '@/layouts/SingleLayout.vue';
import { userMethods, userComputed } from '@/store/adminHelper';

export default {
  name: 'UserSingle',
  components: {
    SingleLayout,
  },
  props: {
    userId: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    fetching: false,
  }),
  computed: {
    ...userComputed,
  },
  created() {
    const { userId } = this;
    this.fetching = true;
    this.editUser({ userId })
      .then(() => {
        this.setCurrent(userId);
        this.fetching = false;
      })
      .catch(() => {
        this.fetching = false;
      });
  },
  destroyed() {
    this.setCurrent(null);
  },
  methods: {
    ...userMethods,
  },
};
</script>
